// Customer authentication API calls
import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';

/**
 * Send OTP to customer email
 */
export async function sendCustomerOtp(email: string) {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/customer/login/send-otp`,
    data: { email },
  });
  return response.data;
}

/**
 * Verify OTP and login customer
 */
export async function verifyCustomerOtp(email: string, otp: string) {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/customer/login/verify-otp`,
    data: { email, otp },
  });
  return response.data;
}
